export const MAX_LEAD_CONTACTS = 50000;

export function normalizeLeadNumber(raw: string): string | null {
  let d = String(raw ?? '').replace(/\D/g, '');
  if (d.length === 12 && d.startsWith('91')) d = d.slice(2);
  else if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
  return /^[1-9]\d{9}$/.test(d) ? d : null;
}

export type LeadPasteResult = {
  contacts: [string, string, string][];
  invalidLines: number[];
  duplicates: number;
};

export function parseLeadPaste(text: string): LeadPasteResult {
  const seen = new Set<string>();
  const contacts: [string, string, string][] = [];
  const invalidLines: number[] = [];
  let duplicates = 0;
  const lines = text.split(/\r?\n/);
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i] ?? '';
    if (!line.trim()) continue;
    const [rawNum = '', first = '', last = ''] = line.split(/[,\t]/);
    const num = normalizeLeadNumber(rawNum);
    if (!num) {
      invalidLines.push(i + 1);
      continue;
    }
    if (seen.has(num)) {
      duplicates++;
      continue;
    }
    seen.add(num);
    contacts.push([num, first.trim().slice(0, 255), last.trim().slice(0, 255)]);
  }
  return { contacts, invalidLines, duplicates };
}
